import { render, staticRenderFns } from "./CertificateTemplate.vue?vue&type=template&id=b3aab326&"
import script from "./CertificateTemplate.vue?vue&type=script&lang=js&"
export * from "./CertificateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports